import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import DescribeDatasourceForm from './form'

const DescribeDatasourceDialog = React.forwardRef(function DescribeDatasourceDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (dataSource) => setDialogState({
      open: true,
      processing: false,
      dataSource
    })
  }), [setDialogState])

  return (
    <SydModal
      title='Describe Datasource'
      open={dialogState.open}
      onClose={close}
      size='md'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <DescribeDatasourceForm
            dataSource={dialogState.dataSource}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </SydModal>
  )
})

DescribeDatasourceDialog.propTypes = {
  onComplete: PropTypes.func
}

DescribeDatasourceDialog.defaultProps = {
  onComplete: () => {}
}

export default DescribeDatasourceDialog
